// import { MapsAPILoader } from '@agm/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GoogleMap } from '@angular/google-maps';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeocodeService } from 'src/app/services/geocode.service';


// only places
declare const google: any;
@Component({
  selector: 'ms-location-map',
  templateUrl: './location-map.component.html',
  styleUrl: './location-map.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LocationMapComponent implements OnInit{
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  zoom = 15;
  markerOptions: google.maps.MarkerOptions = { draggable: true };


  @ViewChild('search', { static: false }) public searchElementRef!: ElementRef;
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  // por defecto para iniciar google
  activeReplace = false
  addressOriginal = ''
  dinamicAddress = ''
  address = '';
  // location: any = {
  //   lat: 14.1007469,
  //   lng: -87.191648
  // }
  centerLocation = {
    lat: 14.1007469,
    lng: -87.191648
  }
  loading: boolean = false;

  loadSave = false

  searchBox: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private location: Location,
    public dialogRef: MatDialogRef<LocationMapComponent>, @Inject(MAT_DIALOG_DATA) public data: any


  ) {  }

  ngOnInit() {
    // this.dialogRef.updateSize('100%')

    //load Places Autocomplete
    // this.mapsAPILoader.load().then((event:any) => {
    //   //this.setCurrentLocation();
    //   let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
    //     types: ["address"]
    //   });
    //   autocomplete.addListener("place_changed", () => {
    //     this.ngZone.run(() => {
    //       //get the place result
    //       let place: any = autocomplete.getPlace();

    //       //verify result
    //       if (place.geometry === undefined || place.geometry === null) {
    //         return;
    //       }
    //       //set latitude, longitude and zoom
    //       this.location.lat = place.geometry.location.lat();
    //       this.location.lng = place.geometry.location.lng();
    //       this.address = place.formatted_address
    //       //this.setlAddressLatLongForm() // para actualizar el formulario
    //       this.cdr.detectChanges();
    //     });
    //   });
    // });

    // this.initAutocomplete();
    if (this.data.latitude && this.data.longitude) {
      this.center = { lat: parseFloat(this.data.latitude), lng: parseFloat(this.data.longitude) };
    }
  }

  // private initAutocomplete() {
  //   const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, { types: ['address'] });

  //   autocomplete.addListener('place_changed', () => {
  //     this.ngZone.run(() => {
  //       const place = autocomplete.getPlace();
  //       if (!place.geometry) return;

  //       this.location = {
  //         lat: place.geometry.location.lat(),
  //         lng: place.geometry.location.lng(),
  //       };
  //       this.address = place.formatted_address;
  //     });
  //   });
  // }

  // mapClicked(event: google.maps.MapMouseEvent) {
  //   if (event.latLng) {
  //     this.location = {
  //       lat: event.latLng.lat(),
  //       lng: event.latLng.lng(),
  //     };
  //   }
  // }

  // markerDragEnd(event: any): void {
  //   if (event && event.latLng) {
  //     this.location = {
  //       lat: event.latLng.lat(),
  //       lng: event.latLng.lng(),
  //     };
  //   }
  // }






  // ready map
  // mapReady(event: any) {

  //   this.map = event;
  //   //const input = document.getElementById('Map-Search');
  //   //this.searchBox = new google.maps.places.SearchBox(input);
  //   this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('CurrentPos'));
  //   this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('SearchCustom'));

  //   /*  this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
  //    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(document.getElementById('Logout')); */

  //   //this.searchBox.addListener('places_changed', () => this.goToSearchedPlace());
  //   this.initForm()

  //   this.map.addListener("dragend", () => {
  //     /* this.maplocation.lat = this.newCenterLat;
  //     this.maplocation.lng = this.newCenterLng; */

  //     console.log("final", this.centerLocation)
  //     this.location.lat = this.centerLocation.lat
  //     this.location.lng = this.centerLocation.lng
  //     this.onGetAddressByLocation(this.location.lat, this.location.lng)
  //     /* this.geocodeService.getAddress(this.newCenterLat, this.newCenterLng).subscribe((location: Ubication) => {
  //       this.address = location.address.toUpperCase();
  //       this.maplocation.address = location.address.toUpperCase();
  //       this.ref.detectChanges();
  //     }); */
  //   });
  // }


  //init maps
  // showLocation() {
  //   this.addressToCoordinates();
  // }

  // markerDragEnd($event:any) {
  //   this.location.lat = $event.coords.lat;
  //   this.location.lng = $event.coords.lng;
  //   this.onGetAddressByLocation(this.location.lat, this.location.lng)
  // }

  // addressToCoordinates() {
  //   this.loading = true;
  //   this.geocodeService.geocodeAddress(this.address)
  //     .subscribe((location: any) => {
  //       console.log(location)
  //       this.location = location;
  //       this.setlAddressLatLongForm() // para actualizar el formulario
  //       this.loading = false;
  //       this.cdr.detectChanges();
  //     }
  //     );
  // }

  // onGetAddressByLocation(la:any, ln:any) {
  //   this.loading = true;
  //   this.geocodeService.getAddress(la, ln)
  //     .subscribe((res: any) => {
  //       console.log("entree", res)
  //       if (res.results.length >= 1) {
  //         //this.zoom = 12;
  //         this.address = res.results[0].formatted_address;
  //         //this.setlAddressLatLongForm() // para actualizar el formulario
  //         this.changeAddres()
  //       } else {
  //         //this.toastr.error("No se encontro resultados")
  //         console.log("No se encontraron Resultados")
  //       }
  //       this.loading = false;
  //       this.cdr.detectChanges();
  //     }
  //     );
  // }
  // end maps

  setlAddressLatLongForm() {
    /* this.form.get('latitude').setValue(this.location.lat)
    this.form.get('longitude').setValue(this.location.lng)
    this.form.get('address').setValue(this.address) */

  }

  // initForm() {
  //   console.log("address", this.data)

  //   if (this.data.latitude != null && this.data.latitude != '' && Number(this.data.latitude) != 0) {
  //     this.location.lat = Number(this.data.latitude)
  //     this.location.lng = Number(this.data.longitude)
  //     this.onGetAddressByLocation(this.location.lat, this.location.lng)
  //     this.addressOriginal = (this.data.address == null ? '' : this.data.address)

  //     this.dinamicAddress = (this.data.address == null ? '' : this.data.address)

  //     //this.setCurrentLocation()
  //   } else {

  //     // COUNTRY SIEMPRE VENDRA

  //     /*  if (this.data.dep == null) {
  //        this.address = this.data.country + (this.data.location_three == null ? (this.data.address == '' ? '' : ', ' + this.data.address) : (', ' + this.data.location_three + (this.data.address == '' ? '' : ' - ' + this.data.address)))

  //      } else {
  //        if (this.data.city == null) {
  //          this.address = this.data.country + ', ' + this.data.dep + (this.data.location_three == null ? (this.data.address == '' ? '' : ', ' + this.data.address) : (', ' + this.data.location_three + (this.data.address == '' ? '' : ' - ' + this.data.address)))


  //        } else {
  //          this.address = this.data.country + ', ' + this.data.dep + ', ' + this.data.city + (this.data.location_three == null ? (this.data.address == '' ? '' : ', ' + this.data.address) : (', ' + this.data.location_three + (this.data.address == '' ? '' : ' - ' + this.data.address)))

  //        }
  //      } */
  //     let dep = (this.data.dep == null ? '' : this.data.dep).toLowerCase()
  //     let city = (this.data.city == null ? '' : this.data.city).toLowerCase()
  //     let district = (this.data.location_three == null ? '' : this.data.location_three).toLowerCase()
  //     let address = (this.data.address == null ? '' : this.data.address)

  //     let res = (address == '' ? '' : (address + ', ')) + (city == '' ? '' : (city + ', ')) + (dep == '' ? '' : (dep + ', ')) + (this.data.country.toLowerCase())

  //     this.address = res
  //     this.addressOriginal = address
  //     this.dinamicAddress = address

  //     this.addressToCoordinates()
  //   }
  // }

  // onSave() {
  //   this.dialogRef.close({
  //     //address: this.address,
  //     address: this.dinamicAddress,
  //     latitude: this.location.lat,
  //     longitude: this.location.lng
  //   })
  // }

  confirmLocation() {
    this.dialogRef.close({
      latitude: this.center.lat,
      longitude: this.center.lng,
      address: "Dirección obtenida"
    });
  }

  changeCheck(e:any) {
    this.activeReplace = e.checked
    this.changeAddres()
  }
  changeAddres() {
    if (this.activeReplace) {
      this.dinamicAddress = this.address
    } else {
      this.dinamicAddress = this.addressOriginal
    }
  }

  onClose() {
    this.dialogRef.close('Close')
  }

  // setCurrentLocation() {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.location.lat = position.coords.latitude;
  //       this.location.lng = position.coords.longitude;
  //       //this.zoom = 8;
  //       this.onGetAddressByLocation(this.location.lat, this.location.lng);
  //     });
  //   } else {
  //     this.onGetAddressByLocation(this.location.lat, this.location.lng)
  //   }
  // }
  centerChange(e:any) {
    this.centerLocation.lat = e.lat
    this.centerLocation.lng = e.lng
  }
}
